import { Box, Grid, Card, CardMedia, CardContent, Typography, Stack, Divider, Pagination } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import FavoriteIcon from '../../../../assets/images/icons/green_heart.png';
import MessageIcon from '../../../../assets/images/icons/message.png';
import EyeIcon from '../../../../assets/images/icons/eye.png';
import { ToolContext } from '../../../../core/context/ToolContext';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';

export const TopContentByViews = () => {
    const { social_media_insight_state } = useContext(ToolContext)
    const platform = social_media_insight_state.connectedPlatform.data;
    const [page, setPage] = useState(1);

    const listView = async () => {
        if (platform == '' ) return;
        try {
            // social_media_insight_state.topContentsLoading.set(true);
            // console.log("social_media_insight_state.topContentsData.data", social_media_insight_state.topContentsData.data);
        } catch (error) {
            console.error('Error fetching social media insights:', error);
            social_media_insight_state.topContentsData.set([]);
        } finally {
            // social_media_insight_state.topContentsLoading.set(false);
        }
    }

    useEffect(() => {
        listView()
    }, [social_media_insight_state.urlCode.data, platform, page])

    const posts = social_media_insight_state.topContentsData.data || [];
    const recordsPerPage = 8;
    const totalPages = Math.ceil(posts.length / recordsPerPage);
    const startIndex = (page - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;
    const currentPosts = posts.slice(startIndex, endIndex);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    return (
        <Box sx={{ flexGrow: 1, marginBottom: "24px" }}>
            <Grid container spacing={3}>
                {social_media_insight_state.topContentsLoading.data ?
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', fontSize: '14px', fontWeight: '600', color: '#666' }}>
                        <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
                    </ Box>
                    :
                    currentPosts.length > 0 ?
                        currentPosts.map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                <Card sx={{ height: '100%', padding: '10px', borderRadius: '10px', border: 'none', boxShadow: 'none' }}>
                                    <CardMedia
                                        component="img"
                                        height="99"
                                        image={item.post_picture}
                                        alt="Post image"
                                        sx={{ objectFit: 'cover', borderRadius: '5px' }}
                                    />
                                    <CardContent sx={{ padding: 0, marginTop: '8px', paddingBottom: '0px !important' }}>
                                        {/* <Typography gutterBottom variant="h6" component="div" fontSize={18} lineHeight="24px" fontWeight={600} marginTop="8px">
                                            Sofa SWLJK
                                        </Typography> */}
                                        <Typography style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }} gutterBottom variant="h6" component="div" color="#979797" fontSize={14} lineHeight="18px" fontWeight={500} minHeight="50px" height="100%" marginTop="10px">
                                            {item?.message?.substring(0, 200)}...
                                        </Typography>
                                        <Divider sx={{ marginTop: '8px', marginBottom: '8px', color: '#E0E0E0' }} />
                                        <Stack direction="row" spacing="10px" alignItems="center">
                                            <Stack direction="row" alignItems="center" spacing="6px">
                                                <img
                                                    src={EyeIcon}
                                                    alt="Eye"
                                                    style={{ width: 16, height: 9, opacity: 0.8, color: '#165320', objectFit: 'contain' }}
                                                />
                                                <Typography variant="body2" color="text.secondary" fontSize={12} fontWeight={500}>
                                                    {item.views}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center" spacing="6px">
                                                <img
                                                    src={FavoriteIcon}
                                                    alt="Favorite"
                                                    style={{ width: 13, height: 13, opacity: 0.8, color: '#165320', objectFit: 'contain' }}
                                                />
                                                <Typography variant="body2" color="text.secondary" fontSize={12} fontWeight={500}>
                                                    {item.likes}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center" spacing="6px">
                                                <img
                                                    src={MessageIcon}
                                                    alt="Message"
                                                    style={{ width: 13, height: 12, opacity: 0.8, color: '#165320', objectFit: 'contain' }}
                                                />
                                                <Typography variant="body2" color="text.secondary" fontSize={12} fontWeight={500}>
                                                    {item.comments}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )) :
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', fontSize: '14px', fontWeight: '600', color: '#666' }}>
                            No data available
                        </Box>
                }
            </Grid>
            {!social_media_insight_state.topContentsLoading.data && currentPosts.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'right', mt: 3 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        size="medium"
                    />
                </Box>
            )}
        </Box>
    );
};